import { render, staticRenderFns } from "./bidirectionalSetTem.vue?vue&type=template&id=37655cfa&scoped=true"
import script from "./bidirectionalSetTem.vue?vue&type=script&lang=js"
export * from "./bidirectionalSetTem.vue?vue&type=script&lang=js"
import style0 from "./bidirectionalSetTem.vue?vue&type=style&index=0&id=37655cfa&prod&lang=scss&scoped=true"
import style1 from "./bidirectionalSetTem.vue?vue&type=style&index=1&id=37655cfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37655cfa",
  null
  
)

export default component.exports